<div class="overread-feedback-card">
  <div class="attribute-row">
    <form-factory [formGroup]="formGroup" [model]="overreadFeedbackEnabled"></form-factory>
  </div>
  <div class="overread-feedback-card__description secondary-text-color">Requires coders to review and acknowledge Overread I feedback.</div>
  <div class="overread-feedback-card__sub-settings">
    <div class="attribute-row">
      <form-factory [formGroup]="formGroup" [model]="requireOverreadFeedback"></form-factory>
      <div class="overread-feedback-card__hint">Turn on Overread I Feedback above to use this setting.</div>
    </div>
    <div class="attribute-row">
      <form-factory [formGroup]="formGroup" [model]="overreadFeedbackChallengeEnabled"></form-factory>
      <div class="overread-feedback-card__hint">Turn on Overread I Feedback above to use this setting.</div>
    </div>
  </div>
</div>

<div class="overread-feedback-card">
  <div class="attribute-row">
    <form-factory [formGroup]="formGroup" [model]="overread2FeedbackEnabled"></form-factory>
  </div>
  <div class="overread-feedback-card__description secondary-text-color">Requires coders to review and acknowledge Overread II feedback.</div>
  <div class="overread-feedback-card__sub-settings">
    <div class="attribute-row">
      <form-factory [formGroup]="formGroup" [model]="requireOverread2Feedback"></form-factory>
      <div class="overread-feedback-card__hint">Turn on Overread II Feedback above to use this setting.</div>
    </div>
    <div class="attribute-row">
      <form-factory [formGroup]="formGroup" [model]="overread2FeedbackChallengeEnabled"></form-factory>
      <div class="overread-feedback-card__hint">Turn on Overread II Feedback above to use this setting.</div>
    </div>
  </div>
</div>
